var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c(
            "a-row",
            { attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽检区县"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽检数量"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 8 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("检测机构"),
                ]),
              ]),
            ],
            1
          ),
          _vm._l(_vm.localValue, function (task) {
            return _c(
              "a-row",
              { style: { margin: "4px" }, attrs: { gutter: 4 } },
              [
                _c("a-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "box" }, [
                    _vm._v(_vm._s(task.regionName)),
                  ]),
                ]),
                _c("a-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "box" }, [
                    _vm._v(_vm._s(task.taskDetail[0].monitTargetCount)),
                  ]),
                ]),
                _c(
                  "a-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "", placeholder: "请选择检测机构" },
                        model: {
                          value: task.execDept,
                          callback: function ($$v) {
                            _vm.$set(task, "execDept", $$v)
                          },
                          expression: "task.execDept",
                        },
                      },
                      _vm._l(_vm.options, function (opt) {
                        return _c(
                          "a-select-option",
                          { key: opt.value, attrs: { value: opt.value } },
                          [_vm._v(" " + _vm._s(opt.name) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "a-row",
            { style: { margin: "4px" }, attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 8 } }),
              _c("a-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "total-box" }, [
                  _vm._v(" 总数量："),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.total)),
                  ]),
                ]),
              ]),
              _c("a-col", { attrs: { span: 8 } }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("地区及机构")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }